import React, { useEffect, useState } from "react";
import { Grid, Icon } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileVideo,
  faImage,
} from "@fortawesome/free-solid-svg-icons";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { API_URL } from "../utils/config";
const MaterialFragment = ({ onMaterialClick, company, course }) => {
  const [materials, setMaterials] = useState([]);
  const [courses, setCourses] = useState([]);
  const [coursesFilter, setCoursesFilter] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(company);
  const [selectedCourse, setSelectedCourse] = useState(course);
  const [selectedType, setSelectedType] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(7);
  const [categoryQuiz, setCategoryQuiz] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    video: null,
    thumbnail: null,
    type: "awareness",
    userID: localStorage.getItem("userId"),
    questions: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchMaterials(currentPage);
  }, [
    currentPage,
    itemsPerPage,
    selectedCompany,
    selectedCourse,
    selectedType,
  ]); // Add formData.company to the dependencies

  useEffect(() => {
    fetchCompanies();
    fetchCategoryQuiz();
    if (company) {
      fetchCourses(company, true);
      fetchCourses(company, false);
    }
  }, []);

  const fetchCategoryQuiz = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(`${API_URL}/categoryQuiz`, requestOptions)
        .then((response) => {
          if (response.status == 401) {
            localStorage.clear();
            window.location.reload();
            return [];
          } else {
            return response.json();
          }
        })
        .then((result) => {
          setCategoryQuiz(result);
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => setCompanies(result))
      .catch((error) => console.error(error));
  };

  const fetchCourses = async (company, isFilter) => {
    console.log(company);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${API_URL}/admin/courses-company/${company}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) =>
        isFilter ? setCoursesFilter(result) : setCourses(result)
      )
      .catch((error) => console.error(error));
  };

  const fetchMaterials = async (currentPage) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      let apiUrl = `${API_URL}/admin/materials?page=${currentPage}&limit=${itemsPerPage}`;
      if (selectedType) {
        apiUrl += `&type=${selectedType}`;
      }
      console.log(apiUrl);
      const response = await fetch(apiUrl, requestOptions);
      if (response.status === 401) {
        localStorage.clear();
        window.location.reload();
        return;
      }
      const data = await response.json();
      console.log(data);
      setMaterials(data.materials);
      setTotalPages(data.totalPages);
      setCurrentPage(data.currentPage);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fileName = formData.thumbnail.name;
      const isPngOrJpg = /\.(png|jpg)$/i.test(fileName);

      if (isPngOrJpg) {
        setIsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem("token"));
        const formdata = new FormData();
        formdata.append("title", formData.title);
        formdata.append("description", formData.description || " "); // Add fallback to empty string
        formdata.append("type", formData.type);
        formdata.append("video", formData.video, formData.video.name);
        formdata.append(
          "thumbnail",
          formData.thumbnail,
          formData.thumbnail.name
        );
        formdata.append(
          "questions",
          JSON.stringify(
            formData.questions.map((question) => ({
              question: question.question,
              notes: question.notes,
              options: question.options,
              category: question.category,
              correctAnswer:
                question.questionType == "single"
                  ? question.correctAnswer
                      .toString()
                      .replace("[", "")
                      .replace("]", "")
                  : question.options[question.correctAnswer],
              isMCQ: question.questionType === "MCQ",
            }))
          )
        );
        formdata.append("userID", formData.userID);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
          timeout: 3600000,
        };

        const logoResponse = await fetch(
          `${API_URL}/admin/material`,
          requestOptions
        );
        if (!logoResponse.ok) {
          throw new Error("Failed to upload logo");
        }
        setFormData({
          title: "",
          description: "",
          video: null,
          thumbnail: null,
          type: "awareness",
          userID: localStorage.getItem("userId"),
          questions: [],
        });
        await fetchMaterials();
        setIsLoading(false);
      } else {
        alert("Thumbnail can only contain png or jpg.");
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, thumbnail: e.target.files[0] });
  };
  const handleFileChangeMaterial = (e) => {
    setFormData({ ...formData, video: e.target.files[0] });
  };

  const handleEdit = (material) => {
    setFormData({
      title: material.title,
      description: material.description,
      type: material.type,
      userID: localStorage.getItem("userId"),
      questions: material.videosWithQuizzes[0].quiz.map((question) => ({
        question: question.question,
        options: question.options,
        category: question.category,
        correctAnswer: question.isMCQ
          ? question.options.indexOf(question.correctAnswer)
          : question.correctAnswer
          ? question.correctAnswer.includes(",")
            ? question.correctAnswer
                .split(",")
                .map((numString) => parseInt(numString, 10))
            : ""
          : "",
        questionType: question.isMCQ
          ? "MCQ"
          : question.correctAnswer
          ? question.correctAnswer.includes(",")
            ? "single"
            : "Assessment"
          : "Assessment",
        notes: question.notes,
      })),
      materialID: material._id,
    });
    setIsEdit(true);
  };

  const handleModify = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const formdata = new FormData();
    formdata.append("title", formData.title);
    formdata.append("type", formData.type);
    formdata.append("description", formData.description || " ");
    if (formData.video) {
      formdata.append("video", formData.video, formData.video.name);
    }
    if (formData.thumbnail) {
      formdata.append("thumbnail", formData.thumbnail, formData.thumbnail.name);
    }
    formdata.append(
      "questions",
      JSON.stringify(
        formData.questions.map((question) => ({
          question: question.question,
          notes: question.notes,
          options: question.options,
          category: question.category,
          correctAnswer:
            question.questionType == "single"
              ? question.correctAnswer
                  .toString()
                  .replace("[", "")
                  .replace("]", "")
              : question.options[question.correctAnswer],
          isMCQ: question.questionType === "MCQ",
        }))
      )
    );
    formdata.append("userID", formData.userID);

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${API_URL}/admin/material/${formData.materialID}`,
      requestOptions
    )
      .then((result) => {
        if (result.ok) {
          alert("Material updated successfully");
          setIsEdit(false);
          setFormData({
            title: "",
            description: "",
            video: null,
            thumbnail: null,
            type: "awareness",
            userID: localStorage.getItem("userId"),
            questions: [],
          });
          fetchMaterials(currentPage);
          setIsLoading(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleDelete = (materialID) => {
    // Display confirmation popup before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this material?"
    );
    if (!isConfirmed) return; // If user cancels, do nothing

    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${API_URL}/admin/material/${materialID}`,
      requestOptions
    )
      .then((result) => {
        if (result.ok) {
          alert("Material deleted successfully");
          fetchMaterials(currentPage);
        }
      })
      .catch((error) => console.error(error));
  };

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function getFileNameAndExtensionFromPath(path) {
    const filenameWithExtension = path.split("/").pop(); // Get filename with extension
    const filenameParts = filenameWithExtension.split("."); // Split filename and extension
    const filename = filenameParts.slice(0, -1).join("."); // Join filename parts (excluding extension)
    const extension = filenameParts.pop(); // Get extension
    return extension;
  }

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <Row>
          <Col
            xs={8}
            style={{
              height: "90vh",
              overflowY: "scroll",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "start",
            }}
          >
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Thumbnail</th>
                  <th>Title/Description</th>
                  {/* <th>Category</th> */}
                  <th>Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {materials.map((material) => {
                  return (
                    <tr key={material._id}>
                      <td
                        onClick={() => {
                          // onMaterialClick(material.company._id, material.courseID, material._id);
                        }}
                      >
                        <img
                          src={`${API_URL}/${material.thumbnail}`}
                          height="50"
                          className="d-inline-block align-center"
                          alt="Logo"
                        />
                      </td>
                      <td
                        onClick={() => {
                          // onMaterialClick(material.company._id, material.courseID, material._id);
                        }}
                      >
                        {material.videosWithQuizzes[0].video.title}
                        <p
                          style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "12px",
                            maxHeight: "2.4em",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            lineHeight: "1.2em",
                          }}
                        >
                          {material.videosWithQuizzes[0].video.description}
                        </p>
                      </td>
                      {/* <td onClick={() => {
                                        // onMaterialClick(material.company._id, material.courseID, material._id);
                                    }}>{capitalizeFirstLetter(material.type)}
                                    </td> */}
                      <td
                        onClick={() => {
                          // onMaterialClick(material.company._id, material.courseID, material._id);
                        }}
                      >
                        {getFileNameAndExtensionFromPath(
                          material.videosWithQuizzes[0].video.video
                        ) == "mp4" ? (
                          <FontAwesomeIcon icon={faFileVideo} />
                        ) : getFileNameAndExtensionFromPath(
                            material.videosWithQuizzes[0].video.video
                          ) == "pdf" ? (
                          <FontAwesomeIcon icon={faFilePdf} />
                        ) : (
                          <FontAwesomeIcon icon={faImage} />
                        )}
                      </td>
                      <td>
                        <EditNoteIcon
                          onClick={() => handleEdit(material)}
                          style={{ color: "green", cursor: "pointer" }}
                        />
                        <DeleteSweepIcon
                          onClick={() => handleDelete(material._id)}
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <div style={{ flex: 1 }} />
            {materials.length > 0 ? (
              <nav aria-label="Courses pagination">
                <ul
                  className="pagination"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <li className="page-item">
                    <select
                      className="form-select form-select-sm"
                      aria-label="Default select example"
                      value={itemsPerPage}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setItemsPerPage(parseInt(e.target.value));
                      }}
                      style={{ height: "40px" }} // Set the height to 100%
                    >
                      <option value="7">7 per page</option>
                      <option value="10">10 per page</option>
                      <option value="50">50 per page</option>
                      <option value="100">100 per page</option>
                    </select>
                  </li>
                  <div style={{ width: "10px" }} />
                  {[...Array(totalPages).keys()].map((page) => (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page + 1)}
                      >
                        {page + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            ) : null}
          </Col>
          {/* Form to Add a School (40% width) */}
          <Col xs={4} style={{ height: "88vh", overflowY: "scroll" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <h4>{isEdit ? "Edit" : "Create"} Material</h4>
              <Button
                variant="secondary"
                onClick={() => {
                  setFormData({
                    title: "",
                    description: "",
                    video: null,
                    thumbnail: null,
                    type: "awareness",
                    userID: localStorage.getItem("userId"),
                    questions: [],
                  });
                  setIsEdit(false);
                }}
              >
                Cancel
              </Button>
            </div>
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={isEdit ? handleModify : handleSubmit}
            >
              <Form.Group controlId="formCompanyName">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Title<span style={{ color: "red" }}> *</span>
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "20px" }}
                  type="text"
                  placeholder="Enter material title"
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group controlId="formCompanyDescription">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Description
                  {/* <span style={{ color: "red" }}> *</span> */}
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "20px" }}
                  as="textarea"
                  rows={3}
                  placeholder="Enter material description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
              </Form.Group>
              {isLoading ? null : (
                <Form.Group controlId="formCompanyLogo">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Upload Thumbnail<span style={{ color: "red" }}> *</span>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    className="w-100"
                    placeholder="Select Thumbnail"
                    accept=".png,.jpg,.jpeg"
                    onChange={handleFileChange}
                    style={{ width: "100%", borderRadius: "20px" }}
                  />
                </Form.Group>
              )}
              {isLoading ? null : (
                <Form.Group controlId="formCompanyLogo">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Upload Material<span style={{ color: "red" }}> *</span>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    className="w-100"
                    placeholder="Select Material"
                    accept=".mp4,.pdf,.png,.jpg,.jpeg"
                    onChange={handleFileChangeMaterial}
                    style={{ width: "100%", borderRadius: "20px" }}
                  />
                  <Form.Label
                    style={{
                      fontWeight: "500",
                      borderRadius: "20px",
                      fontSize: "12px",
                    }}
                  >
                    Select only .mp4,.pdf,.png,.jpg,.jpeg
                  </Form.Label>
                </Form.Group>
              )}
              <div style={{ height: "10px" }} />
              <div
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h6
                  style={{
                    flex: 1,
                    fontWeight: "500",
                    borderRadius: "20px",
                    alignSelf: "center",
                  }}
                >
                  Quiz Content
                </h6>
              </div>
              <div style={{ height: "10px" }} />
              {formData.questions.map((question, questionIndex) => (
                <div
                  key={questionIndex}
                  style={{
                    backgroundColor: "#F6F6F6",
                    marginBottom: "10px",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <h6
                      style={{
                        fontWeight: "500",
                        borderRadius: "20px",
                        alignSelf: "center",
                      }}
                    >
                      Question {questionIndex + 1}
                    </h6>
                    <DeleteSweepIcon
                      onClick={() => {
                        const newQuestions = [...formData.questions];
                        newQuestions.splice(questionIndex, 1); // Remove question
                        setFormData({ ...formData, questions: newQuestions });
                      }}
                      style={{ color: "red", cursor: "pointer" }}
                    />
                  </div>
                  <Form.Group controlId={`formCategory${questionIndex}`}>
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Category
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      as="select"
                      value={question.category}
                      onChange={(e) => {
                        const newQuestions = [...formData.questions];
                        newQuestions[questionIndex].category = e.target.value;
                        setFormData({ ...formData, questions: newQuestions });
                      }}
                    >
                      <option value="">Select a category</option>
                      {categoryQuiz.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group controlId={`formQuestionType${questionIndex}`}>
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <Form.Label
                        style={{
                          fontWeight: "500",
                          borderRadius: "20px",
                          margin: "0px",
                          padding: "0px",
                        }}
                      >
                        Question Type:
                      </Form.Label>
                      <div style={{ width: "10px" }} />
                      <Form.Check
                        type="radio"
                        label="MCQ"
                        checked={question.questionType === "MCQ"}
                        onChange={(e) => {
                          const newQuestions = [...formData.questions];
                          newQuestions[questionIndex].questionType = "MCQ";
                          newQuestions[questionIndex].correctAnswer = 0;
                          newQuestions[questionIndex].options = [...Array(4)];
                          setFormData({ ...formData, questions: newQuestions });
                        }}
                      />
                      <div style={{ width: "10px" }} />
                      <Form.Check
                        type="radio"
                        label="Single"
                        checked={question.questionType === "single"}
                        onChange={(e) => {
                          const newQuestions = [...formData.questions];
                          newQuestions[questionIndex].questionType = "single";
                          newQuestions[questionIndex].correctAnswer = [];
                          newQuestions[questionIndex].options = [...Array(4)];
                          setFormData({ ...formData, questions: newQuestions });
                        }}
                      />
                      <div style={{ width: "10px" }} />
                      <Form.Check
                        type="radio"
                        label="Assessment"
                        checked={question.questionType === "Assessment"}
                        onChange={(e) => {
                          const newQuestions = [...formData.questions];
                          newQuestions[questionIndex].questionType =
                            "Assessment";
                          newQuestions[questionIndex].correctAnswer = "";
                          newQuestions[questionIndex].options = [...Array(4)];
                          setFormData({ ...formData, questions: newQuestions });
                        }}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group controlId="formQuestion">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Question
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      as="textarea"
                      rows={2}
                      placeholder="Enter the question"
                      value={question.question}
                      onChange={(e) => {
                        const newQuestions = [...formData.questions];
                        newQuestions[questionIndex].question = e.target.value;
                        setFormData({ ...formData, questions: newQuestions });
                      }}
                    />
                  </Form.Group>
                  {/* Options */}
                  {question.questionType === "MCQ" && (
                    <div>
                      <Form.Group controlId={`formOptions${questionIndex}`}>
                        <Form.Label
                          style={{ fontWeight: "500", borderRadius: "20px" }}
                        >
                          Options
                        </Form.Label>
                        {question.options.map((option, index) => (
                          <div
                            key={index}
                            className="mb-3"
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Form.Check
                              type="radio"
                              id={`option${index}`}
                              name={`correctAnswer${questionIndex}`}
                              value={index}
                              checked={question.correctAnswer === index}
                              onChange={(e) => {
                                const newQuestions = [...formData.questions];
                                newQuestions[questionIndex].correctAnswer =
                                  index;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                            <div style={{ width: "10px" }} />
                            <Form.Control
                              className="w-100"
                              style={{ width: "100%", borderRadius: "20px" }}
                              type="text"
                              value={option}
                              placeholder={`Option ${index + 1}`}
                              onChange={(e) => {
                                const newQuestions = [...formData.questions];
                                const newOptions = [...question.options];
                                newOptions[index] = e.target.value;
                                newQuestions[questionIndex].options =
                                  newOptions;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                          </div>
                        ))}
                      </Form.Group>
                    </div>
                  )}
                  {question.questionType === "single" && (
                    <div>
                      <Form.Group controlId={`formOptions${questionIndex}`}>
                        <Form.Label
                          style={{ fontWeight: "500", borderRadius: "20px" }}
                        >
                          Options
                        </Form.Label>
                        {question.options.map((option, index) => (
                          <div
                            key={index}
                            className="mb-3"
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Form.Check
                              type="checkbox" // Change type to "checkbox"
                              id={`option${index}`}
                              name={`correctAnswer${questionIndex}`}
                              value={index}
                              checked={question.correctAnswer.includes(index)} // Check if the index is included in correctAnswer array
                              onChange={() => {
                                const newQuestions = [...formData.questions];
                                const newCorrectAnswer =
                                  question.correctAnswer.includes(index)
                                    ? question.correctAnswer.filter(
                                        (item) => item !== index
                                      )
                                    : [
                                        ...newQuestions[questionIndex]
                                          .correctAnswer,
                                        index,
                                      ];
                                newQuestions[questionIndex].correctAnswer =
                                  newCorrectAnswer;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                            <div style={{ width: "10px" }} />
                            <Form.Control
                              className="w-100"
                              style={{ width: "100%", borderRadius: "20px" }}
                              type="text"
                              placeholder={`Option ${index + 1}`}
                              value={option}
                              onChange={(e) => {
                                const newQuestions = [...formData.questions];
                                const newOptions = [...question.options];
                                newOptions[index] = e.target.value;
                                newQuestions[questionIndex].options =
                                  newOptions;
                                setFormData({
                                  ...formData,
                                  questions: newQuestions,
                                });
                              }}
                            />
                          </div>
                        ))}
                      </Form.Group>
                    </div>
                  )}
                  <Form.Group controlId="formQuestion">
                    <Form.Label
                      style={{ fontWeight: "500", borderRadius: "20px" }}
                    >
                      Notes
                    </Form.Label>
                    <Form.Control
                      className="w-100"
                      style={{ width: "100%", borderRadius: "20px" }}
                      type="text"
                      as="textarea"
                      rows={2}
                      placeholder="Enter the notes"
                      value={question.notes}
                      onChange={(e) => {
                        const newQuestions = [...formData.questions];
                        newQuestions[questionIndex].notes = e.target.value;
                        setFormData({ ...formData, questions: newQuestions });
                      }}
                    />
                  </Form.Group>
                </div>
              ))}
              {/* Add question button */}
              <Button
                variant="outline-primary"
                size="sm"
                elevation={3}
                className="w-100"
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginBottom: "5px",
                }}
                onClick={() => {
                  setFormData((prevState) => ({
                    ...prevState,
                    questions: [
                      ...prevState.questions,
                      {
                        question: "",
                        options: [{ optionText: "", weightage: "" }],
                      },
                    ],
                  }));
                }}
              >
                Add Question
              </Button>
              <Button
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginTop: "5px",
                }}
                elevation={3}
                className="w-100"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}
                {isEdit ? "Modify" : "Create"} Material
              </Button>
              <div style={{ height: "10px" }} />
            </Form>
          </Col>
        </Row>
      </Container>
    </Grid>
  );
};

export default MaterialFragment;
